import { defineMessages } from "react-intl";

export const scope = "pages.MemberPlatformBalancePage";

export const messages = defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: "Balances de {name}",
  },
  totalBalance: {
    id: `${scope}.totalBalance`,
    defaultMessage: "Saldo total",
  },
  otherCurrencies: {
    id: `${scope}.otherCurrencies`,
    defaultMessage: "Otros activos",
  },
  inAccount: {
    id: `${scope}.inAccount`,
    defaultMessage: "En cuenta",
  },
  activeInvestmentTea: {
    id: `${scope}.activeInvestmentTea`,
    defaultMessage: "Ganando {tea}% TEA",
  },
  investPill: {
    id: `${scope}.investPill`,
    defaultMessage: "Inversión disponible",
  },
});
